module.exports = new Function('try{return this===global;}catch(err){return false;}');
